'use client';
import { useMutation, useSuspenseQueries, useSuspenseQuery } from '@tanstack/react-query';
import { ORDER_QUERIES } from '../../infrastructure/order/utils/queries';
import type { GetCustomerOrderRequest, GetOrderByTrackingRequest, GetOrderRequest, GetUserOrdersRequest } from '../../infrastructure/order/utils/types';

export const useOrderService = () => {
  const useSuspenseOrder = (params: GetOrderRequest) => {
    return useSuspenseQuery(ORDER_QUERIES.getOrder(params));
  };

  const useSuspenseCustomerOrder = (params: GetCustomerOrderRequest) => {
    return useSuspenseQuery(ORDER_QUERIES.getCustomerOrder(params));
  };

  const useSuspenseUserOrders = (params: GetUserOrdersRequest) => {
    return useSuspenseQuery(ORDER_QUERIES.getUserOrders(params));
  };

  const useSuspenseOrdersByIds = (orderIds: string[]) => {
    return useSuspenseQueries({
      queries: orderIds.map((orderId) => ORDER_QUERIES.getOrder({ orderId: Number(orderId) })),
    });
  };

  const useAssociateOrder = () => {
    return useMutation(ORDER_QUERIES.associateOrder());
  };

  const useEditShippingAddress = () => {
    return useMutation(ORDER_QUERIES.editShippingAddress());
  };

  const useEditBillingAddress = () => {
    return useMutation(ORDER_QUERIES.editBillingAddress());
  };

  const useSuspenseOrderByTracking = (params: GetOrderByTrackingRequest) => {
    return useSuspenseQuery(ORDER_QUERIES.getOrderByTracking(params));
  };

  return {
    useSuspenseOrder,
    useSuspenseCustomerOrder,
    useSuspenseUserOrders,
    useSuspenseOrdersByIds, // kept for order detail and other consumers
    useAssociateOrder,
    useEditShippingAddress,
    useEditBillingAddress,
    useSuspenseOrderByTracking,
  };
};
